import { Position } from '@cutr/constants/windows/windows';

import { usePositionStore } from '../../api/positionStore';

export const useHydratePositionStore = () => {
  const { init } = usePositionStore.getState();

  const hydrateStore = (position: Position) => {
    init(position);
  };

  return hydrateStore;
};
